module.exports = __webpack_public_path__ + "img/m_stu.c506f962.svg";